import React from 'react';
import { format as formatDate } from 'date-fns'
import frLocale from 'date-fns/locale/fr';

export const FormattedDate = ({ date, format, locale = frLocale, className }) => {
  try {
    const formatted = formatDate(new Date(date), format, { locale });

    return (
      <time className={className} dateTime={date}>{formatted}</time>
    )
  } catch (e) {
    return null;
  }
}

export default FormattedDate;
